import { Icon, type INamedIconProps } from '@public/components/Icon/Icon';

export const WithdrawnIcon = ({ ...props }: INamedIconProps) => (
  <Icon
    height="12"
    iconName="Withdrawn"
    viewBox="0 0 22 18"
    y="25%"
    {...props}
  />
);
